export const columns = [
  {
    title: "系统名称",
    width: 150,
    key: "systemName",
    slots: { customRender: "systemName" },
  },{
    title: "材料编号",
    width: 200,
    dataIndex: "materialNo",
    key: "materialNo",
  },
  {
    title: "材料名称",
    width: 200,
    dataIndex: "materialName",
    key: "materialName",
  },
  {
    title: "规格型号",
    width: 150,
    dataIndex: "materialModel",
    key: "materialModel",
  },
  {
    title: "品牌",
    width: 100,
    dataIndex: "materialBrand",
    key: "materialBrand",
  },
  {
    title: "结算单位",
    width: 100,
    dataIndex: "materialUnit",
    key: "materialUnit",
  },
  {
    title: "PO采购数量",
    width: 150,
    dataIndex: "purchaseOrderCount",
    key: "purchaseOrderCount",
  },
  {
    title: "收货单签收数量",
    width: 150,
    dataIndex: "currentSignCount",
    key: "currentSignCount",
  },
];
